import {
  EtxeApiSlugs,
  FileId,
  ListPagination,
  PatchPropertyModerationEntryStatusDto,
  PropertyAddMediaDto,
  PropertyAdminDashboardMetricsDto,
  PropertyDocumentStatus,
  PropertyDto,
  PropertyId,
  PropertyModerationStatus,
} from '@workspace/data-types';
import { Observable } from 'rxjs';
import { ApiCaller } from '../../../../../api-caller.service';
import { ApiEntityStateConnector } from '../../../../../api-entity-state-connector.abstract-service';
import { QueryParamsUtils } from '../../../../../utils';

export class EtxePropertiesAdminConnector extends ApiEntityStateConnector<
  PropertyDto,
  PropertyDto,
  PropertyId
> {
  constructor(apiCaller: ApiCaller, apiPrefix: string) {
    super(apiCaller, apiPrefix, EtxeApiSlugs.PROPERTIES);
  }

  getDashboardMetrics(): Observable<PropertyAdminDashboardMetricsDto> {
    return this.apiCaller.getRequest<PropertyAdminDashboardMetricsDto>(
      this.apiPrefix,
      `${this.slug}/metrics/dashboard`,
    );
  }

  summerized = () => ({
    list: (pagination?: ListPagination): Observable<PropertyDto[]> =>
      this.apiCaller.getRequest<PropertyDto[]>(
        this.apiPrefix,
        `${this.slug}/all${QueryParamsUtils.buildFilterParams(pagination)}`,
      ),
    count: (pagination?: ListPagination): Observable<number> =>
      this.apiCaller.getRequest<number>(
        this.apiPrefix,
        `${this.slug}/all/count${QueryParamsUtils.buildFilterParams(pagination, true)}`,
      ),
  });

  patchDocumentStatus(
    propertyId: PropertyId,
    fileId: FileId,
    status: PropertyDocumentStatus,
    rejectionReason?: string,
  ): Observable<PropertyDto> {
    return this.apiCaller.patchRequest<PropertyDto>(
      this.apiPrefix,
      `${this.slug}/${propertyId}/document/${fileId}/status`,
      { status, rejectionReason },
    );
  }

  patchModerationEntryStatus(
    propertyId: PropertyId,
    entryId: string,
    status: PropertyModerationStatus,
    note?: string,
  ): Observable<PropertyDto> {
    return this.apiCaller.patchRequest<PropertyDto>(
      this.apiPrefix,
      `${this.slug}/${propertyId}/moderation/entry/${entryId}/status`,
      { status, note } as PatchPropertyModerationEntryStatusDto,
    );
  }

  patchPhotos(propertyId: PropertyId, media: PropertyAddMediaDto): Observable<PropertyDto> {
    return this.apiCaller.patchRequest<PropertyDto>(
      this.apiPrefix,
      `${this.slug}/${propertyId}/photos`,
      media,
    );
  }
}
